import ReactDOM from 'react-dom';
import React from 'react';
import RootRouter from './RootRouter';
import "./style/index.less"

const render = ()=>{
    ReactDOM.render(
        <RootRouter/>,
        document.getElementById("root"),
    )
}

render()
